<template>
    <div class="fendan-manager">
        <p class="plugin-header">
            订单分拣
        </p>
        <div class="fendan-info">
            进入分单模式，进行单条/批量订单分拣，或管理自己的专属分单词库
        </div>
        <div class="fendan-tools">
            <a class="fendan-btn" href="#">进入分单</a>
        </div>
    </div>
</template>

<script>

export default {
    name: 'FendanManager',
    components: {

    },
    data() {
        return {

        }
    },
    mounted() {


    },
    methods: {


    }
}

</script>

<style scoped>
.fendan-manager {
    position: relative;
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    scrollbar-width: none;
}

.plugin-header {
    height: 36px;
    padding-left: 10px;
    padding-right: 10px;
    background-color: #edf0f5;
    line-height: 36px;
    color: #576d8b;
}
.fendan-info {
    min-height: 100px;
    padding: 10px;
    font-size: 12px;
    color: #576d8b;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.3);
}
.fendan-tools{
    height: 34px;
    text-align: right;
    margin-top: 30px;
    margin-right: 6px;
}

.fendan-btn {
    background-color: #0095ff;
    border: 1px solid #0095ff;
    color: #fff;
    margin-top: 4px;
    padding: 5px 10px;
    font-size: 12px;
    line-height: 1.5;
    border-radius: 3px;
}

</style>